// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1RQhG","actionsCol":"EnrolledClinics_actionsCol__3TNlX"};